import { LOCALES, KEYS } from '../constants';

const frFRTranslations = Object.freeze({
  [LOCALES.L18N_LOCALE_FRENCH_FR]: {
    [KEYS.L18N_KEY_LABEL_PARTNER_ROLE ]:"Rôle du partenaire",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR ]:"Intégrateur",
    [KEYS.L18N_KEY_LABEL_PROVIDER ]:"Fournisseur",
    [KEYS.L18N_KEY_LABEL_PARTNER_LEVEL]:"Niveau du partenaire",
    [KEYS.L18N_KEY_LABEL_PARTNER_SPECIALIZATION ]:"Spécialisation du partenaire",
    [KEYS.L18N_KEY_LABEL_CISCO_POWERED_SERVICE ]:"Service Cisco Powered",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME ]:"Nom du partenaire",
    [KEYS.L18N_KEY_LABEL_LOCATION ]:"Lieu",
    [KEYS.L18N_KEY_LABEL_COUNTRY ]:"Pays",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME_KEYWORD ]:"Mot-clé du nom du partenaire",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME_KEYWORD_S_ ]:"Mots-clés du nom du partenaire",
    [KEYS.L18N_KEY_LABEL_SORTING ]:"Trier",
    [KEYS.L18N_KEY_LABEL_SPECIALIZATIONS ]:"Spécialisations",
    [KEYS.L18N_KEY_LABEL_PARTNER_SPECIALIZATIONS ]:"Spécialisations du partenaire",
    [KEYS.L18N_KEY_LABEL_PROVIDER_LEVEL_AND_CISCO_POWERED_SERVICES ]:"Niveau de fournisseur et services Cisco Powered",
    [KEYS.L18N_KEY_LABEL_GOLD_PROVIDER ]:"fournisseur Gold",
    [KEYS.L18N_KEY_LABEL_PREMIER_PROVIDER ]:"fournisseur Premier",
    [KEYS.L18N_KEY_LABEL_SELECT_PROVIDER ]:"fournisseur Select",
    [KEYS.L18N_KEY_LABEL_ELOQUA__GET_GUIDANCE]:"Obtenir des conseils",
    [KEYS.L18N_KEY_LABEL_ELOQUA__REQUEST_A_QUOTE ]:"Demander un devis",
    [KEYS.L18N_KEY_LABEL_OPEN ]:"En cours",
    [KEYS.L18N_KEY_LABEL_EXPAND ]:"Développer",
    [KEYS.L18N_KEY_LABEL_COLLAPSE ]:"Réduire",
    [KEYS.L18N_KEY_LABEL_CHOOSE_A_COUNTRY ]:"Choisir un pays/une région",
    [KEYS.L18N_KEY_LABEL_CHOOSE_A_ROLE ]:"Choisir un rôle",
    [KEYS.L18N_KEY_LABEL_CHOOSE_SPECIALIZATION_S_ ]:"Choisir une ou plusieurs spécialisations",
    [KEYS.L18N_KEY_LABEL_CHOOSE_CISCO_POWERED_SERVICE_S_ ]:"Choisir un ou plusieurs services Cisco Powered",
    [KEYS.L18N_KEY_LABEL_CHOOSE_EXPERTISE_S]:"Choisir une ou plusieurs expertises",
    [KEYS.L18N_KEY_LABEL_CHOOSE_LEVEL_S_ ]:"Choisir un ou plusieurs niveaux",
    [KEYS.L18N_KEY_LABEL_PARTNER_COUNTRY ]:"Pays/région partenaire",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR_LEVELS ]:"Niveaux d'intégrateur",
    [KEYS.L18N_KEY_LABEL_PROVIDER_LEVELS ]:"Niveaux de fournisseur",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR_SPECIALIZATIONS ]:"Spécialisations de l'intégrateur",
    [KEYS.L18N_KEY_LABEL_CISCO_POWERED_SERVICES ]:"Services Cisco Powered",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAMES ]:"Noms des partenaires",
    [KEYS.L18N_KEY_LABEL_BACK ]:"Retour",
    [KEYS.L18N_KEY_LABEL_ALL_RESULTS]:"Tous les résultats",
    [KEYS.L18N_KEY_LABEL_ALL ]:"Tous",
    [KEYS.L18N_KEY_LABEL_SAVED ]:"Enregistrés",
    [KEYS.L18N_KEY_LABEL_MY_PARTNERS ]:"Mes partenaires",
    [KEYS.L18N_KEY_LABEL_ADD ]:"Ajouter",
    [KEYS.L18N_KEY_LABEL_REMOVE ]:"Supprimer",
    [KEYS.L18N_KEY_LABEL_ADD_TO_COMPARE ]:"Ajouter pour comparer ",
    [KEYS.L18N_KEY_LABEL_SELECT_AT_LEAST_ONE_MORE ]:"Sélectionnez-en au moins un autre",
    [KEYS.L18N_KEY_LABEL_COMPARE_SELECTED ]:"Comparer la sélection ",
    [KEYS.L18N_KEY_LABEL_REMOVE_FROM_COMPARATOR ]:"Supprimer du comparateur",
    [KEYS.L18N_KEY_LABEL_COMPARE ]:"Comparaison",
    [KEYS.L18N_KEY_LABEL_PARTNER_LEVEL ]:"Niveau de partenariat",
    [KEYS.L18N_KEY_LABEL_PROCESSING_IN_PROGRESS]:"Traitement en cours",
    [KEYS.L18N_KEY_LABEL_RESULT ]:"résultat",
    [KEYS.L18N_KEY_LABEL_RESULTS ]:"résultats",
    [KEYS.L18N_KEY_LABEL_NO_RESULTS ]:"Aucun résultat",
    [KEYS.L18N_KEY_LABEL_RESULT_IN]:"résultat dans",
    [KEYS.L18N_KEY_LABEL_RESULTS_IN]:"résultats dans",
    [KEYS.L18N_KEY_LABEL_NO_RESULTS_IN]:"Aucun résultat dans",
    [KEYS.L18N_KEY_LABEL_PREVIOUS ]:"Précédent",
    [KEYS.L18N_KEY_LABEL_PREV ]:"Précédent",
    [KEYS.L18N_KEY_LABEL_NEXT ]:"Suivant",
    [KEYS.L18N_KEY_LABEL_SAVE ]:"Enregistrer",
    [KEYS.L18N_KEY_LABEL_EXPERTISE ]:"Expertise",
    [KEYS.L18N_KEY_LABEL_OVERVIEW ]:"Présentation",
    [KEYS.L18N_KEY_LABEL_IS_A_CISCO ]:"travaille auprès de Cisco en tant que",
    [KEYS.L18N_KEY_LABEL_ROLE_INTEGRATOR_DESCRIPTION]:"Les intégrateurs créent des solutions complètes pour nos clients. Ils effectuent principalement des transactions dans le cadre d'une revente, en contribuant à régler les problèmes des clients grâce à leur expertise.",
    [KEYS.L18N_KEY_LABEL_ROLE_PROVIDER_DESCRIPTION ]:"Les fournisseurs sont des experts dans la fourniture de solutions managées et cloud. Les clients recherchent plus de flexibilité dans la façon dont ils utilisent les solutions, et les fournisseurs prennent de plus en plus d'importance sur le marché.",
    [KEYS.L18N_KEY_LABEL_PAST_SEARCHES ]:"Recherches passées",
    [KEYS.L18N_KEY_LABEL_PAST_SEARCH ]:"Recherche passée",
    [KEYS.L18N_KEY_LABEL_ROLES ]:"Rôles ",
    [KEYS.L18N_KEY_LABEL_TECHNOLOGY ]:"Technologie",
    [KEYS.L18N_KEY_LABEL_INDUSTRIES ]:"Secteurs d'activité",
    [KEYS.L18N_KEY_LABEL_INTEGRATORS ]:"Intégrateurs",
    [KEYS.L18N_KEY_LABEL_PROVIDERS ]:"Fournisseurs",
    [KEYS.L18N_KEY_LABEL_OTHER ]:"Autre",
    [KEYS.L18N_KEY_LABEL_OTHERS ]:"Autres",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_OTHER_PARTNERS]:"Aucun autre partenaire enregistré",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_INTEGRATORS ]:"Aucun intégrateur enregistré",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_PROVIDERS ]:"Aucun fournisseur enregistré",
    [KEYS.L18N_KEY_LABEL_FILTER_BY_NEED ]:"filtrer par besoin",
    [KEYS.L18N_KEY_LABEL_SEARCH_BY_COMBINED_CRITERIA ]:"rechercher par critères combinés",
    [KEYS.L18N_KEY_LABEL_SEARCH_BY_LOCATION ]:"rechercher par lieu",
    [KEYS.L18N_KEY_LABEL_THERE_IS_ONE_PARTNER_SERVING_WORLDWIDE]:"Il y a un partenaire opérant dans le monde entier",
    [KEYS.L18N_KEY_LABEL_THERE_ARE]:"Il y a",
    [KEYS.L18N_KEY_LABEL_PARTNERS_SERVING_WORLDWIDE]:"partenaires opérant dans le monde entier",
    [KEYS.L18N_KEY_LABEL_THERE_ARE_ONE_NO_PARTNERS_SERVING]:"Aucun partenaire n'opère dans le monde entier",
    [KEYS.L18N_KEY_LABEL_THERE_IS_ONE_PARTNER_SERVING_IN]:"Il y a un partenaire opérant dans la zone",
    [KEYS.L18N_KEY_LABEL_PARTNERS_SERVING_IN]:"partenaires opérant dans la zone",
    [KEYS.L18N_KEY_LABEL_THERE_ARE_ONE_PARTNERS_SERVING_IN]:"Aucun partenaire n'opère dans la zone",
    [KEYS.L18N_KEY_LABEL_CHANGE_LOCATION]:"Modifier le lieu",
    [KEYS.L18N_KEY_LABEL_FILTER_BY_NEED]:"Filtrer par besoin",
    [KEYS.L18N_KEY_LABEL_SEARCH]:"Rechercher",
    [KEYS.L18N_KEY_LABEL_BY_NAME_ONE_LEVEL_AND_EXPERTISE]:"par nom, niveau et expertise",
    [KEYS.L18N_KEY_LABEL_SELECTED]:"sélectionné",
    [KEYS.L18N_KEY_LABEL_NO_MATCHES_FOUND]:"Aucun résultat trouvé",
    [KEYS.L18N_KEY_LABEL_RANK_UP]:"Précédent",
    [KEYS.L18N_KEY_LABEL_RANK_DOWN]:"Suivant",
    [KEYS.L18N_KEY_LABEL_NAME_UP]:"Nom précédent",
    [KEYS.L18N_KEY_LABEL_NAME_DOWN]:"Nom suivant",
    [KEYS.L18N_KEY_LABEL_LOGIN_REQUIRED]:"Connexion obligatoire",
    [KEYS.L18N_KEY_LABEL_YOU_MUST_ONE_PERFORM_THIS_ACTION]:"Vous devez vous connecter pour effectuer cette action",
    [KEYS.L18N_KEY_LABEL_SEARCH_RESTORATION_FAILED]:"Échec de la restauration de la recherche",
    [KEYS.L18N_KEY_LABEL_LOG_IN]:"Se connecter",
    [KEYS.L18N_KEY_LABEL_PARTNER_SUCCESSFULLY_SAVED]:"Partenaire enregistré",
    [KEYS.L18N_KEY_LABEL_THE_PARTNER_ONE_NOT_BE_SAVED]:"Le partenaire n'a pas pu être enregistré",
    [KEYS.L18N_KEY_LABEL_PARTNER_SUCCESSFULLY_REMOVED]:"Partenaire supprimé",
    [KEYS.L18N_KEY_LABEL_THE_PARTNER_ONE_NOT_BE_DELETED]:"Le partenaire n'a pas pu être supprimé",
    [KEYS.L18N_KEY_LABEL_TYPE_A_ONE_LEVEL_OR_EXPERTISE]:"Saisissez un mot-clé pour effectuer une recherche par nom, niveau ou expertise",
    [KEYS.L18N_KEY_LABEL_ROLE_DEVELOPER_DESCRIPTION]:"Les développeurs sont des experts qui créent des solutions logicielles et matérielles sur mesure reposant sur la technologie Cisco. Ils contribuent à composer des solutions uniques entre les systèmes dans le but d'obtenir des résultats concrets.",
    [KEYS.L18N_KEY_LABEL_ROLE_ADVISOR_DESCRIPTION]:"Les conseillers sont des experts dont la connaissance approfondie du secteur leur permet de guider les entreprises dans leur recherche de solution répondant à des défis complexes.​",
    [KEYS.L18N_KEY_LABEL_DIVERSE_PARTNER]:"Partenaire inclusif",
    [KEYS.L18N_KEY_LABEL_ALPHABETICAL]:"Par ordre alphabétique",
    [KEYS.L18N_KEY_LABEL_MOST_EXPERTISE]:"Plus haut niveau de compétence",
    [KEYS.L18N_KEY_LABEL_DEVELOPER]:"Développeur",
    [KEYS.L18N_KEY_LABEL_ADVISOR]:"Conseiller",

    [KEYS.L18N_KEY_LABEL_FILTERS]:"Filtres",
    [KEYS.L18N_KEY_LABEL_FILTER_VERB]:"Filtrer",
    [KEYS.L18N_KEY_LABEL_PARTNER_EXPERTISE]:"Expertise du partenaire",
    [KEYS.L18N_KEY_LABEL_DISMISS_VERB]:"Ignorer",
    [KEYS.L18N_KEY_LABEL_SPECIALIZATION]:"Specialisation",
    [KEYS.L18N_KEY_LABEL_EXPERTISES]:"Expertises",
    [KEYS.L18N_KEY_LABEL_NO_DESCRIPTION_PROVIDED_DOT]: 'Description non spécifiée.',
    [KEYS.L18N_KEY_LABEL_ABOUT]:'A propos de',
    [KEYS.L18N_KEY_LABEL_CLEAR_COMPARATOR]:'Vider le comparateur',
    [KEYS.L18N_KEY_LABEL_PARTNER_COMPARISON]: 'Comparaison de partenaires',
    [KEYS.L18N_KEY_LABEL_ROLE]: 'Rôle',
    [KEYS.L18N_KEY_LABEL_TECHNOLOGICAL_FOCUS]: 'Orientation technologique',
    [KEYS.L18N_KEY_LABEL_DESCRIPTION]: 'Description',
    [KEYS.L18N_KEY_LABEL_CHOOSE_LANGUAGE_SELECTION]: 'Choisir la langue sélectionnée',
    [KEYS.L18N_KEY_LABEL_LOG_OUT]:"Se déconnecter",
    [KEYS.L18N_KEY_LABEL_INCLUSIVE_PARTNER]:"Partenaire inclusif",

    [KEYS.L18N_KEY_LABEL_ABOUT_CISCO]: "A propos de Cisco",
    [KEYS.L18N_KEY_LABEL_CONTACT_US]: "Nous Contacter",
    [KEYS.L18N_KEY_LABEL_CAREERS]: "Carrières",
    [KEYS.L18N_KEY_LABEL_MEET_OUR_PARTNERS]: "Rencontrer nos Partenaires",
    [KEYS.L18N_KEY_LABEL_FEEDBACK]: "Retour d'information",
    [KEYS.L18N_KEY_LABEL_HELP]: "Aide",
    [KEYS.L18N_KEY_LABEL_TERMS_AND_CONDITIONS]: "Termes & Conditions",
    [KEYS.L18N_KEY_LABEL_PRIVACY_STATEMENT]: "Déclaration de confidentialité",
    [KEYS.L18N_KEY_LABEL_COOKIES]: "Cookies",
    [KEYS.L18N_KEY_LABEL_TRADEMARKS]: "Marques",
    [KEYS.L18N_KEY_LABEL_SUPPLY_CHAIN_TRANSPARENCY]: "Transparence de la chaîne logistique",
    [KEYS.L18N_KEY_LABEL_SITEMAP]: "Plan du site",
    [KEYS.L18N_KEY_LABEL_HOW_TO_BUY]: "Comment Acheter",
    [KEYS.L18N_KEY_LABEL_PARTNERS]: "Partenaires",
    [KEYS.L18N_KEY_LABEL_PRODUCTS_AND_SERVICES]: "Produits et Services",
    [KEYS.L18N_KEY_LABEL_SOLUTIONS]: "Solutions",
    [KEYS.L18N_KEY_LABEL_SUPPORT]: "Support",
    [KEYS.L18N_KEY_LABEL_LEARN]: "Apprendre",
    [KEYS.L18N_KEY_LABEL_EXPLORE_CISCO]: "Explorer Cisco",
    [KEYS.L18N_KEY_LABEL_MENU]: "Menu",
    [KEYS.L18N_KEY_LABEL_CLOSE]: "Fermer",
    [KEYS.L18N_KEY_LABEL_SEE_MORE]: "Voir plus",
    [KEYS.L18N_KEY_LABEL_SEE_LESS]: "Voir moins",
    [KEYS.L18N_KEY_LABEL_DONT_HAVE_AN_ACCOUNT]: "Pas de compte?",
    [KEYS.L18N_KEY_LABEL_SIGN_UP]: "s'enregistrer"
  }}
);

export default frFRTranslations;
